"use client";

import { useEffect, useRef, useState } from "react";
import TourOperator from "@/lib/Types/TourOperator";
/* eslint-disable @next/next/no-img-element */

const LOGO_BASE_URL =
  "https://media.staticroot.com/DAM/Commercial%20Partners/Tour%20Operators/TO%20logos";

interface TourOperatorLogoProps {
  tourOperator?: TourOperator;
  height?: number;
  width?: number;
  className?: string;
}

const TourOperatorLogo = ({
  tourOperator,
  height = 30,
  width = 80,
  className = "",
}: TourOperatorLogoProps) => {
  // ImageKit file paths are case-sensitive (Cloudinary was not) and DAM logo
  // filenames have mixed casing, so fall back to the original code on 404.
  const [useOriginalCase, setUseOriginalCase] = useState(false);
  const imgRef = useRef<HTMLImageElement>(null);

  // When the img is server-rendered, the 404 error event can fire before
  // hydration attaches onError — detect that case after mount.
  useEffect(() => {
    const img = imgRef.current;
    if (img && img.complete && img.naturalWidth === 0) {
      setUseOriginalCase(true);
    }
  }, []);

  if (!tourOperator) return null;

  const fileName = useOriginalCase
    ? tourOperator.code
    : tourOperator.code.toLowerCase();

  return (
    <img
      ref={imgRef}
      className={className}
      src={`${LOGO_BASE_URL}/${fileName}.png`}
      height={height}
      width={width}
      alt={tourOperator.name}
      title={tourOperator.name}
      onError={() => {
        if (!useOriginalCase) setUseOriginalCase(true);
      }}
    />
  );
};

export default TourOperatorLogo;
